<div id="load-change-container">
  <div id="top-row">
    <span class="energyToolWidgetTitle">{{ "energy_tool.load_changes.load_change" | translate }} </span>
    @if (!loading() && !timeOut()) {
      <select
        class="custom_select"
        (change)="onChangeTimeSelect($event)"
        id="time-window-button"
        [value]="selectedTimeWindow()"
      >
        <option value="total">
          {{ "energy_tool.load_changes.total" | translate }}
        </option>
        <option value="today">
          {{ "energy_tool.load_changes.today" | translate }}
        </option>
        <option value="yesterday">
          {{ "energy_tool.load_changes.yesterday" | translate }}
        </option>
        <option value="this_week">
          {{ "energy_tool.load_changes.this_week" | translate }}
        </option>
        <option value="this_month">
          {{ "energy_tool.load_changes.this_month" | translate }}
        </option>
      </select>
    }
  </div>
  <div id="display-container" [ngClass]="{ loadingContainer: loading() }">
    @if (timeOut()) {
      <app-timeout></app-timeout>
    } @else if (loading()) {
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    } @else {
      @if (loadChanges() !== undefined) {
        <div id="text-container">
          <span>
            {{ loadChanges() | number: "" : "de-DE" }}
          </span>
          @if (lastActionTimestamp() !== "") {
            <span class="font-size-sm"
              >{{ "energy_tool.load_changes.last_operation" | translate }}:

              {{ lastActionTimestamp() }}
            </span>
          }
        </div>

        <app-svg-icon iconName="load-change" iconSize="l" iconColor="primary"></app-svg-icon>
      } @else {
        <span class="noData">{{ "common.no_data" | translate }}</span>
      }
    }
  </div>
</div>
